import axios from "axios";
import { Base_URL } from "../url";

export const fetchCities = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CityMaster/GetAllCities`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching cities!";
  }
};

export const downloadCitiesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/CityMaster/DownloadCitiesExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading cities data!";
  }
};